export const goldPriceSeries = [
  { i: 0, price: 4386.4, marker: '' },
  { i: 1, price: 4391.2, marker: '' },
  { i: 2, price: 4388.7, marker: '' },
  { i: 3, price: 4395.9, marker: '' },
  { i: 4, price: 4401.3, marker: '' },
  { i: 5, price: 4397.8, marker: 'WAIT' },
  { i: 6, price: 4404.2, marker: '' },
  { i: 7, price: 4410.6, marker: '' },
  { i: 8, price: 4407.1, marker: '' },
  { i: 9, price: 4413.5, marker: '' },
  { i: 10, price: 4419.8, marker: '' },
  { i: 11, price: 4415.4, marker: '' },
  { i: 12, price: 4421.7, marker: 'ENTRY' },
  { i: 13, price: 4428.3, marker: '' },
  { i: 14, price: 4434.9, marker: '' },
  { i: 15, price: 4431.2, marker: '' },
  { i: 16, price: 4438.6, marker: '' },
  { i: 17, price: 4445.1, marker: '' },
  { i: 18, price: 4441.8, marker: '' },
  { i: 19, price: 4448.4, marker: '' },
  { i: 20, price: 4455.2, marker: 'EXIT' },
  { i: 21, price: 4449.7, marker: '' },
  { i: 22, price: 4443.3, marker: '' },
  { i: 23, price: 4450.6, marker: '' },
  { i: 24, price: 4457.9, marker: '' },
  { i: 25, price: 4453.2, marker: 'WAIT' },
  { i: 26, price: 4460.4, marker: '' },
  { i: 27, price: 4467.8, marker: '' },
  { i: 28, price: 4462.8, marker: 'ENTRY' },
  { i: 29, price: 4456.1, marker: '' },
  { i: 30, price: 4449.4, marker: '' },
  { i: 31, price: 4445.3, marker: 'EXIT' },
  { i: 32, price: 4452.7, marker: '' },
  { i: 33, price: 4459.2, marker: '' },
  { i: 34, price: 4466.5, marker: '' },
  { i: 35, price: 4474.1, marker: 'WAIT' },
];
